import { render, staticRenderFns } from "./LinkObjectDialog.vue?vue&type=template&id=9a988a82&scoped=true&"
import script from "./LinkObjectDialog.vue?vue&type=script&lang=js&"
export * from "./LinkObjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkObjectDialog.vue?vue&type=style&index=0&id=9a988a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a988a82",
  null
  
)

export default component.exports